import React from "react";
import "../styles/EmptyStateIndicator.css";

const CustomEmptyState = () => {
    return (
        <div className="h-full flex-center custom-empty">
            Send a message to get started!
        </div>
    );
};
export default CustomEmptyState;